import { lazyNamed } from 'src/utils/lazyNamed';

export const PositionGroups = {
  PositionGroupsList: lazyNamed(() => import('./pages/PositionGroupsList'), 'PositionGroupsList'),
  PositionGroupForm: lazyNamed(() => import('./pages/PositionGroupForm'), 'PositionGroupForm'),
  PositionsForm: lazyNamed(() => import('./pages/PositionsForm'), 'PositionsForm'),
};
